// extracted by mini-css-extract-plugin
export default {"product":"Product_product__+ohRT","input":"Product_input__a5+IW","button":"Product_button__6E0AK"};